import React from "react";

import ContactUs from "../ContactUs";

export default function SignUp() {
  return <ContactUs />;
}
